// extracted by mini-css-extract-plugin
module.exports = {"container":"logo_container__3UXbu","logo":"logo_logo__2K-Sn"};